export const getQueryString = name => {
  var reg = new RegExp('(^|&|)' + name + '=([^&]*)(&|$)')
  var url =
    window.location.hash.substr(1) ||
    window.location.search ||
    window.location.href
  var r = url.match(reg)
  if (r !== null) {
    return unescape(r[2])
  }
  return null
}

export const isEmpty = value => {
  if (
    value === undefined ||
    value === null ||
    value.toString().replace(/\s+/g, '') === ''
  ) {
    return true
  } else {
    return false
  }
}

export const dateFormat = (date, fmt) => {
  if (fmt === undefined || fmt === null) {
    fmt = 'yyyy-MM-dd HH:mm:ss'
  }
  var o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours() % 12 === 0 ? 12 : date.getHours() % 12,
    'H+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    S: date.getMilliseconds()
  }
  var week = {
    '0': '/u65e5',
    '1': '/u4e00',
    '2': '/u4e8c',
    '3': '/u4e09',
    '4': '/u56db',
    '5': '/u4e94',
    '6': '/u516d'
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  if (/(E+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (RegExp.$1.length > 1
        ? RegExp.$1.length > 2
          ? '/u661f/u671f'
          : '/u5468'
        : '') + week[this.getDay() + '']
    )
  }
  for (var k in o) {
    let rg = '(' + k + ')'
    if (new RegExp(rg).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}

export const deepObjectMerge = (target, ...objects) => {
  target = target || {}
  let len = objects.length
  for (let i = 0; i < len; i++) {
    let SecondOBJ = objects[i]
    for (var key in SecondOBJ) {
      target[key] =
        target[key] && target[key].toString() === '[object Object]'
          ? deepObjectMerge(target[key], SecondOBJ[key])
          : (target[key] = SecondOBJ[key])
    }
  }
  return target
}

// 时间戳转日期格式
export const dateByTimestamp = (timestamp, fmt) => {
  var newDate = new Date()
  newDate.setTime(timestamp)
  return newDate
}

export const setCookie = (cname, cvalue, exdays) => {
  if (navigator.cookieEnabled) {
    let d = new Date()
    if (!exdays) {
      exdays = 7
    }
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let expires = 'expires=' + d.toGMTString()
    document.cookie = cname + '=' + cvalue + '; ' + expires
  } else if (localStorage) {
    let d = new Date()
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
    let curTime = d.getTime()
    localStorage.setItem(
      cname,
      JSON.stringify({ data: cvalue, time: curTime })
    )
  }
}

export const getCookie = cname => {
  if (navigator.cookieEnabled) {
    var name = cname + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i].trim()
      if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
    }
    return ''
  } else if (localStorage) {
    var data = localStorage.getItem(cname)
    var dataObj = JSON.parse(data)
    if (new Date().getTime() < dataObj.time) {
      var dataObjDatatoJson = JSON.parse(dataObj.data)
      return dataObjDatatoJson
    }
  }
  return ''
}

export const navigatorLanguage = function () {
  var type = navigator.appName
  var lang = ''
  if (type === 'Netscape') {
    lang = navigator.language
  } else {
    lang = navigator.userLanguage
  }
  lang = lang.substr(0, 2)
  return lang
}

export const getLanguage = function () {
  let cookieName = encodeURIComponent('language') + '='
  let cookieStart = document.cookie.indexOf('language')
  let cookieValue = null
  let cookieEnd
  if (cookieStart >= 0) {
    cookieEnd = document.cookie.indexOf(';', cookieStart)
    if (cookieEnd < 0) {
      cookieEnd = document.cookie.length
    }
    cookieValue = decodeURIComponent(
      document.cookie.substring(cookieStart + cookieName.length, cookieEnd)
    )
  }
  let langs = getQueryString('language')
  return cookieValue || langs || 'en'
}

// 邮箱掩码
export const emailFormat = function (input) {
  var output = input
  if (input === null || input === '' || input === undefined) return output
  output = input.trim()
  var emailParts = input.split('@')
  if (emailParts.length > 1) {
    if (emailParts[0].length > 3) {
      output =
        emailParts[0].substr(0, 2) +
        '***' +
        emailParts[0].substr(emailParts[0].length - 1)
    } else if (emailParts[0].length > 0) {
      output = emailParts[0].substr(0, 1) + '***'
    }
    output += '@' + emailParts[1]
  }
  return output
}

// 手机号掩码 182******82
export const phoneFormat = function (value) {
  if (value) {
    return value.substring(0, 3) + '*****' + value.substring(value.length - 2)
  }
}



// WEBPACK FOOTER //
// ./src/cdpBase/utils/index.js